import styled from 'styled-components';

export const InformationItemsArea = styled.div<{ imgWidth?: string; hasDescription?: boolean }>`
  display: flex;
  flex-direction: ${(props) => (props.hasDescription ? 'column' : 'row')};
  padding: var(--spacing-4, 16px) var(--spacing-4, 16px) var(--spacing-8, 30px)
    var(--spacing-4, 16px);
  align-items: flex-start;
  align-self: stretch;

  > div.header > span {
    font-family: Manrope, sans-serif;
    font-weight: 600;
    font-style: SemiBold;
    font-size: 18px;
    leading-trim: NONE;
    line-height: 26px;
    letter-spacing: 2%;
    color: #000;
  }

  > span.description {
    color: var(--escala-de-cinza-90, #101010);
    font-family: Manrope, sans-serif;
    font-weight: 500;
    font-style: Medium;
    font-size: 16px;
    leading-trim: NONE;
    line-height: 24px;
    letter-spacing: 3%;
  }

  > div.header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  > div.header > div.img-area {
    display: flex;
    padding: 6px;
    justify-content: center;
    align-items: center;
    gap: 10px;

    &.border {
      border-radius: 110px;
      border: 1.5px solid var(--Primary-Purple, #5768ff);
    }

    > img {
      width: ${(props) => props.imgWidth || '21px'};
      height: ${(props) => props.imgWidth || '21px'};
    }
  }
`;
